import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { IArticle } from '../../../types'
import { ArticleItem } from '../../molecules/ArticleItem'
import { NoContent } from '../../atoms/NoContent'

type Props = {
  items: IArticle[]
  withLink?: boolean
}

export const ArticleItemList: FC<Props> = ({ items = [], withLink = false }) => {
  const { t } = useTranslation(['articles'])
  if (items.length === 0) {
    return <NoContent>{t('記事がまだ掲載されていません。')}</NoContent>
  }

  return (
    <div className={styles.container}>
      {items.map((item) => {
        return (
          <div key={item.slug} className={styles.item}>
            <ArticleItem article={item} withLink={withLink} />
          </div>
        )
      })}
    </div>
  )
}
